import React,  { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReportThumbnail from './ReportThumbnail';
import Button from 'react-bootstrap/Button';

export default function ReportBanner({ report, userCount }) {
    return (
        <div className={'report-download bg-gray-300'}>
            <Row className={'align-items-center justify-content-center content-styling'}>
                <div className={'pe-sm-3'}>
                    <a href={report.url}>
                        <ReportThumbnail reports={[report]} tripleThumb={false} />
                    </a>
                </div>
                <div className={'text-secondary d-flex flex-column'}>
                    <div className={'pt-3 pt-sm-0 container-sm-none'}>
                        <a className={'link-secondary fw-bold font-24'} href={report.url}>
                            Download free report
                        </a>
                    </div>
                    <div className={'py-2 container-sm-none'}>
                        Find out what your peers are saying about {report.title}. <b>Updated {report.updated}</b>
                    </div>
                    <Col sm={12} lg={8} xl={6} className={'pb-2'}>
                        <a href={report.url}><Button variant={'danger'} className={'btn-block fs-6 fs-sm-5 my-3'}>DOWNLOAD NOW</Button></a>
                    </Col>
                    <div>
                        {userCount} professionals have used our research since 2012.
                    </div>
                </div>
            </Row>
        </div>
    )
}